import DocumentCategory from "./DocumentCategory";

export default interface Document {
  documentId: string;
  documentName: string;
  documentDescription: string;
  documentType: string;
  active: boolean;
  documentPath: string;
  file: File;
  public: boolean;
  documentCategories: DocumentCategory[];
  documentCategoryIds: string[];
  version: string;
  ownedDocumentFlag: boolean;
}

export enum DocumentType {
  Form = "FORM",
  Handbook = "HANDBOOK_MANUAL",
}
